/**
 * Super-Admin Login Page.
 */
import React, { useState } from 'react';
import { Button, Card, Form, Input, Typography, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useSAStore } from '../../store/superAdminStore';
import '../../authPages.css';

const { Title, Text } = Typography;

const SALoginPage: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const login = useSAStore((s) => s.login);

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      await login(values.email, values.password);
      message.success('Добро пожаловать, Super Admin!');
      navigate('/superadmin');
    } catch {
      message.error('Неверный логин или пароль');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="zhorka-auth-page">
      <Card className="zhorka-auth-card">
        <div className="zhorka-auth-brand">
          <div className="zhorka-auth-brandline"><img src={`${import.meta.env.BASE_URL}favicon.svg`} alt="" /><strong>Жорка</strong></div>
          <span className="zhorka-auth-eyebrow">Управление платформой</span>
          <Title level={3}>Вход администратора</Title>
          <Text type="secondary">Доступ к настройкам платформы.</Text>
        </div>
        <Form onFinish={onFinish} layout="vertical">
          <Form.Item name="email" rules={[{ required: true, message: 'Email' }]}>
            <Input prefix={<UserOutlined />} placeholder="Email" size="large" />
          </Form.Item>
          <Form.Item name="password" rules={[{ required: true, message: 'Пароль' }]}>
            <Input.Password prefix={<LockOutlined />} placeholder="Пароль" size="large" />
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" size="large" block loading={loading}>
              Войти
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default SALoginPage;
